import React, { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import api from '../../services/api';
import { FormatarData } from '../../utils/Utils';
import Logo from '../../assets/logo.png';
import { LandscapeOrientation } from '../../utils/landscapeOrientation';

function LancamentosEmAberto() {
    let { clienteFornecedorId, dataInicial, dataFinal } = useParams();
    const [relatorio, setRelatorio] = useState([]);
    const [statusPedidos, setStatusPedidos] = useState();
    const [isLoadingPdf, setIsLoadingPdf] = useState(false);

    useEffect(() => {
        async function fetchData() {
            let url = `/RelatorioPedidos/lancamentosporclientefornecedor/${clienteFornecedorId}/${dataInicial}/${dataFinal}`;
            await api.get(url).then(response => {
                setRelatorio(response ? response.data : []);
            });
            await api.get('/Pedido/listaStatus').then(response => {
                setStatusPedidos(response ? response.data : null);
            });
        }
        fetchData();
    }, [clienteFornecedorId, dataInicial, dataFinal]);

    const gerarPdfComissao = async () => {
        if (!relatorio || relatorio.length === 0) return;
        setIsLoadingPdf(true);
        try {
            const pedidosIds = relatorio.map(linha => linha.Id || linha.id);
            await api.post('/RelatorioPedidos/cobraComissao', pedidosIds, {
                responseType: 'blob'
            }).then(response => {
                const file = new Blob([response.data], { type: 'application/pdf' });
                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            });
        } catch (err) {
            alert('Erro ao gerar o PDF');
        }
        setIsLoadingPdf(false);
    };

    return (
        <div style={{ width: '100%', paddingLeft: 15, paddingRight: 15 }}>
            <LandscapeOrientation />
            <div style={{ fontSize: 12 }} className="row pr-3 pl-3 pt-3">
                <div style={{ width: 150 }}>
                    <img className='logo' src={Logo} alt="Logo" />
                </div>
                <div className="pl-2">
                    <b>Lançamentos por Cliente/Fornecedor</b><br />
                    <b>Fornecedor: </b> {relatorio && relatorio[0]?.Fornecedor}<br />
                    <b>Status: </b> {relatorio && statusPedidos && relatorio[0] ? (statusPedidos.find(s => s.value === relatorio[0].StatusPedido)?.label || '-') : '-'}<br />
                    {<FormatarData data={dataInicial} />} a {<FormatarData data={dataFinal} />}
                </div>
            </div>
            <div className="mt-2 mb-2">
                <button
                    className="btn btn-primary"
                    disabled={!relatorio || relatorio.length === 0 || isLoadingPdf}
                    onClick={gerarPdfComissao}
                >
                    {isLoadingPdf ? "Gerando PDF..." : "Gerar PDF de Comissão"}
                </button>
            </div>
            <div className="relatorio table-responsive mt-2">
                <table style={{ width: '100%' }} cellPadding="3px" className="table table-bordered table-sm">
                    <thead>
                        <tr>
                            <th scope="col">Nº Ped</th>
                            <th scope="col">Cliente</th>
                            <th scope="col">Comprador</th>
                            <th scope="col">Dt Compra</th>
                            <th scope="col">Dt Prev Faturamento</th>
                            <th scope="col">Dt Faturamento</th>
                            <th scope="col" style={{ textAlign: "right" }}>Total de Peças</th>
                            <th scope="col" style={{ textAlign: "right" }}>Custo Total</th>
                            <th scope="col" style={{ textAlign: "center" }}>Valor Comissão</th>
                            <th scope="col" style={{ textAlign: "center" }}>% Comissão</th>
                        </tr>
                    </thead>
                    <tbody>
                        {relatorio && relatorio.map((linha, index) => (
                            <tr key={index} style={{ fontSize: 12 }}>
                                <td>{linha.Numero}</td>
                                <td>{linha.Cliente}</td>
                                <td>{linha.Comprador}</td>
                                <td>{<FormatarData data={linha.DataCompra} />}</td>
                                <td>{<FormatarData data={linha.DataPrevisaoFaturamento} />}</td>
                                <td>{<FormatarData data={linha.DataFaturamento} />}</td>
                                <td style={{ textAlign: "right" }}>{linha.TotalPecas?.toLocaleString('pt-br', { maximumFractionDigits: 0 })}</td>
                                <td style={{ textAlign: "right" }}>{linha.CustoLiquido?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                <td style={{ textAlign: "right" }}>{linha.ValorComissao?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                                <td style={{ textAlign: "right" }}>
                                    {linha.CustoLiquido ? ((linha.ValorComissao / linha.CustoLiquido) * 100).toLocaleString('pt-br', { maximumFractionDigits: 2 }) : '0.00'}%
                                </td>
                            </tr>
                        ))}
                        <tr style={{ fontWeight: "bold" }}>
                            <td colSpan={6}>{relatorio ? relatorio.length : 0} pedidos</td>
                            <td>Total:</td>
                            <td style={{ textAlign: "right" }}>{relatorio.reduce((a, v) => a = a + (v.TotalPecas || 0), 0).toLocaleString('pt-br', { maximumFractionDigits: 0 })}</td>
                            <td style={{ textAlign: "right" }}>{relatorio.reduce((a, v) => a = a + (v.CustoLiquido || 0), 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                            <td style={{ textAlign: "right" }}>{relatorio.reduce((a, v) => a = a + (v.ValorComissao || 0), 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <br />
        </div>
    );
}

export default LancamentosEmAberto;
